//* Libraries imports
import z from "zod";

//* Schemas imports
import { nameSchema } from "../../name";
import { dateFormat } from "../../date";

export const paginatedProcess = z.object({
  id: z.number(),
  name: nameSchema,
  start: dateFormat,
  end: dateFormat,
  description: z.string(),
  online: z.boolean(),
  simulation: z.number(),
  createdAt: dateFormat,
});
export type PaginatedProcess = z.infer<typeof paginatedProcess>;

export const fullProcess = z
  .object({
    updatedAt: dateFormat,
    rules: z.string(),
    typeFiscalization: z.string(),
    isFinished: z.boolean(),
    mobile: z.boolean(),
    examPerTime: z.boolean(),
    interview: z.boolean(),
    fullScreen: z.boolean(),
    chatType: z.string(),
    saveTimer: z.number(),
    saveTimerPreExam: z.number(),
    mockExam: z.number(),
    blocked: z.boolean(),
    movement: z.boolean(),
    goodQuality: z.boolean(),
    examTime: z.number().nullable(),
    timeType: z.string(),
    screenExtendedRestrict: z.boolean(),
    screenSharing: z.boolean(),
    replaceVideoScreen: z.boolean(),
    showDraft: z.boolean(),
    restrictAccess: z.boolean(),
    timeInitRestrict: z.string().nullable(),
    timeEndRestrict: z.string().nullable(),
    college: z.object({
      id: z.number(),
      name: z.string(),
      slug: z.string(),
    }),
    test: z.array(
      z.object({
        id: z.number(),
        name: z.string(),
        totalQuestions: z.number(),
        disciplines: z.array(
          z.object({
            id: z.number(),
            name: z.string(),
            questionsCount: z.number(),
            questionsNumbers: z.array(
              z.object({
                id: z.number(),
                number: z.number(),
              })
            ),
          })
        ),
      })
    ),
  })
  .merge(paginatedProcess);
export type FullProcess = z.infer<typeof fullProcess>;




